import { RestockPullType } from "../Enums";
import Item from "./Item";
import LabelTemplate from "./LabelTemplate";
import Site from "./Site";

export default class ItemSiteSetting{
  constructor(
    public id: number,
    public site: Site,
    public item: Item,
    public defaultLabelQuantity: number,
    public defaultLabelTemplate: LabelTemplate | undefined,
    public restockPullType: RestockPullType,
    public canOrderManually: boolean,
  ) {}
}